module.exports = __webpack_public_path__ + "static/conference03-a0c782ca8db5e8b6b7862d0a948aa1b8.jpg";